import _t from 'i18n!nls/front-page';

const getNewReleasesSpotlightCollectionsData = () => {
  return {
    headline: _t('Hot new releases'),
    description: '',
    ctaText: _t('Explore courses'),
    ctaTarget: '/explore/new-on-coursera',
    collectionSets: [
      {
        id: 'new-on-coursera-spotlight',
        collectionModuleId: 'promo-template-preset-collection',
        presetCollectionId: 'vePjWxvaRzOPzgw5b2Vapw',
      },
    ],
  };
};

export default getNewReleasesSpotlightCollectionsData;
